const SEARCH_HISTORY = "SEARCH_HISTORY";

export const getHistory = (): Array<string> => {
  const history = localStorage.getItem(SEARCH_HISTORY.toString());
  const historyParsed = history ? JSON.parse(history) : [];

  return historyParsed;
};

export const getLastHistory = (): string => {
  const history = getHistory();

  return history[history.length - 1];
};

export const isInHistory = (id: string): boolean => {
  const history: Array<string> = getHistory();

  return history.indexOf(id) !== -1;
};

export const addToHistory = (id: string): void => {
  if (!isInHistory(id)) {
    const history = getHistory();
    history.push(id);
    localStorage.setItem(SEARCH_HISTORY.toString(), JSON.stringify(history));
  }
};
